import { useMemo } from 'react';
import { IAddress } from '../../shared';
import { getCountry } from '../../shared/utils/origins.util';

export const useAddressFormatter = (address?: IAddress) => {
    return useMemo(() => {
        if (!address) return '';

        return [
            `${address.street || ''} ${address.number || ''} ${address.box || ''}`.trim(),
            `${address.postalCode || ''} ${address.city || ''}`.trim(),
            getCountry(address.country)?.label || '',
        ]
            .filter(Boolean)
            .join(', ');
    }, [address]);
};
